import { useTheme } from '@/hooks/use-theme';
import { type ReactNode } from 'react';

export function ThemeProvider({ children }: { children: ReactNode }) {
    // Hook'u burada çağırıyoruz - bu theme class'larını HTML'e uygulayacak
    useTheme();
    
    return <>{children}</>;
}

